import { useOrderStatusLabel } from 'hooks/business/chat/useOrder';

export const Status = ({ tradeStatus }: { tradeStatus?: Conversation.Trade.Status }) => {
  const orderStatusLabel = useOrderStatusLabel(tradeStatus ?? 'WAITING_PAY');
  if (tradeStatus === 'TRADE_SUCCESS') {
    return (
      <span className="text-[var(--fett-scenario-success-text)] bg-[var(--fett-surface-success-bg)] px-1 py-0.5 rounded-sm">
        {orderStatusLabel}
      </span>
    );
  }
  if (tradeStatus === 'CANCEL') {
    return (
      <span className="text-[var(--fett-surface-error-text)] bg-[var(--fett-surface-error-bg)] px-1 py-0.5 rounded-sm">
        {orderStatusLabel}
      </span>
    );
  }
  return (
    <span className="text-[var(--fett-scenario-accent-text)] bg-[var(--fett-scenario-accent-bg)] px-1 py-0.5 rounded-sm">
      {orderStatusLabel}
    </span>
  );
};
